// Shop mega-menu 3+9 department rail.
// Hover (or first tap) switches the right-hand panel; a second click follows the hub URL.
(function() {
  'use strict';

  if (window.__t4sMegaRailInit) return;
  window.__t4sMegaRailInit = true;

  function activate(rail, id) {
    if (!rail || id == null) return;
    var key = String(id);

    rail.querySelectorAll('[data-mega-rail-parent]').forEach(function(el) {
      var on = el.getAttribute('data-mega-rail-parent') === key;
      el.classList.toggle('is-active', on);
      if (on) {
        el.setAttribute('aria-current', 'true');
      } else {
        el.removeAttribute('aria-current');
      }
    });

    rail.querySelectorAll('[data-mega-rail-panel]').forEach(function(el) {
      var on = el.getAttribute('data-mega-rail-panel') === key;
      el.classList.toggle('is-active', on);
      if (on) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });

    if (window.scheduleMegaMenuRelayout) {
      window.scheduleMegaMenuRelayout(rail);
    }
  }

  function parentFromEvent(e) {
    var target = e.target;
    if (!target || !target.closest) return null;
    return target.closest('[data-mega-rail-parent]');
  }

  document.addEventListener('mouseover', function(e) {
    var parent = parentFromEvent(e);
    if (!parent) return;
    var rail = parent.closest('[data-mega-rail]');
    if (!rail) return;
    activate(rail, parent.getAttribute('data-mega-rail-parent'));
  }, true);

  document.addEventListener('focusin', function(e) {
    var parent = parentFromEvent(e);
    if (!parent) return;
    var rail = parent.closest('[data-mega-rail]');
    if (!rail) return;
    activate(rail, parent.getAttribute('data-mega-rail-parent'));
  });

  document.addEventListener('click', function(e) {
    var parent = parentFromEvent(e);
    if (!parent) return;
    var rail = parent.closest('[data-mega-rail]');
    if (!rail) return;
    if (parent.classList.contains('is-active')) return;
    e.preventDefault();
    e.stopPropagation();
    activate(rail, parent.getAttribute('data-mega-rail-parent'));
  }, true);

  document.addEventListener('keydown', function(e) {
    var parent = parentFromEvent(e);
    if (!parent) return;
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var rail = parent.closest('[data-mega-rail]');
    if (!rail) return;
    var items = Array.prototype.slice.call(rail.querySelectorAll('[data-mega-rail-parent]'));
    var index = items.indexOf(parent);
    if (index < 0) return;
    var next = e.key === 'ArrowDown' ? items[index + 1] : items[index - 1];
    if (!next) return;
    e.preventDefault();
    next.focus();
    activate(rail, next.getAttribute('data-mega-rail-parent'));
  });
})();
